import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';

import getCurrentBreakpoint from '@project/shared/utils/breakpoints/js/breakpoints';

const classes: any = {
	wrapper: 'body',
	stateSticky: 'state-m-navigation--is-sticky',
	stateOnTop: 'state-m-navigation--scroll-0-position',
	stateScrollUp: 'state-m-navigation--scroll-forward',
	stateScrollTopNoTransition: 'state-m-navigation--scroll-0-position-no-transition',
	burgerActiveClass: 'state-m-burgernav--visible',
	initSticky: 'state-m-navigation--initialized',
	headerWrapper: 'js-o-header-wrapper',
	headerStickyBar: 'js-o-header__sticky-bar',
	headerStickyBarHideNav: 'o-header__sticky-bar--hide-navigation',
	pageShare: 'm-page-share',
	ctaButton: 'js-sticky-cta',
	logoLink: 'm-logo',
};

let preventStickyHeaderAppearing = false;
let preventStickyHeaderScrollBehaviour = false;
let noHasAnchor = false;
let noHasPageShare = false;

@createModule('Header')
/**
* Header module implementation.
*
* @author Heiko Frosch <heiko.frosch@namics.com>
*/
export class Header extends TerrificSpec {
	$ctx: JQuery;
	start(resolve: Function) {
		const $ctx = $(this._ctx);
		this._initStickyHeader($ctx);
		this.$ctx = $(this._ctx);
		this.track();
		$(window).on('enablePreventStickyHeaderAppearing', () => {
			preventStickyHeaderAppearing = true;
		});

		$(window).on('enablePreventStickyScrollBehaviour', () => {
			preventStickyHeaderScrollBehaviour = true;
		});

		$(window).on('disablePreventStickyScrollBehaviour', () => {
			preventStickyHeaderScrollBehaviour = false;
		});
		$(window).on('setHeaderMargin', (event: any, margin: number) => {
			const windowHeight = $(window).height();
			margin = Math.min(margin, windowHeight);

			if (margin >= windowHeight) {
				$(classes.wrapper).css('max-width', $(classes.wrapper).innerWidth());
				$(classes.wrapper).css('overflow', 'hidden');
			} else {
				$(classes.wrapper).css('overflow', '');
				$(classes.wrapper).css('max-width', '');
			}

			const headerMargin = $(classes.wrapper).hasClass(classes.stateOnTop)
				? 0
				: margin;
			$(classes.wrapper).css('margin-top', margin + 'px');
			$(`.${classes.headerWrapper}`, $ctx).css('top', headerMargin + 'px');
		});

		$(window).on('disablePreventStickyHeaderAppearing', () => {
			preventStickyHeaderAppearing = false;
		});

		$('html').addClass(this.$ctx.data('t-classname'));

		this.$ctx.find('.js-backhistory').on('click', this.gobackHistory);

		this._initNavInPage();

		if (window.location.search.substr(1).indexOf('event') > -1) {
			$(`.${classes.logoLink}`).attr(
				'href',
				$('header[data-t-name="header"]').attr('data-t-newlisturl')
			);
		}
		this.hideEmptyMenu();
		$(window).on('resize', () => { this.hideEmptyMenu(); });
		resolve();
	}
	stop() { }

	/**
	 * method tracks event
	 *
	 * @param {string} action  tracking action name
	 * @param {string} value   tracking value
	 * @returns {void}
	 */
	track() {
		var queryString = location.search.substr(1);
		let pageCampaignId = $('header').data('page-mktocampaign-id');
		let utmId =
			queryString !== undefined
				? queryString.indexOf('utm_id=') !== -1
					? queryString.split('utm_id=')[1].split('&')[0]
					: undefined
				: undefined;

		if (utmId === undefined) {
			if (pageCampaignId === undefined) {
				utmId = '';
			} else {
				utmId = pageCampaignId;
			}
		}

		const trackdata: {
			osc_id: string;
		} = {
			osc_id: utmId,
		};

		Track.gtmTrack(trackdata);
	}

	hideEmptyMenu() {
		const viewport = getCurrentBreakpoint() as string;
		/* if (viewport === 'small' || viewport === 'medium') {} */
		if (viewport === "small") {
			$(".m-navigation-main__list-level1").each(function (e) {
				if ($(this).children().length > 0) {
					$(this).closest(".js-m-navigation-wrapper").show();
					$(".js-search-trigger").show();
					$(".a-search-trigger").show();
					$(".a-burger").show();
				} else {
					$(this).closest(".js-m-navigation-wrapper").hide();
					$(".js-search-trigger").hide();
					$(".a-burger").hide();
					$(".a-search-trigger").hide();
					$('a.js-backhistory[href="#"]').hide();
				}
			});
		}
	}

	getDeviceType() {
		if (/mobile/i.test(navigator.userAgent)) {
			return 'mobile';
		} else if (/tablet/i.test(navigator.userAgent)) {
			return 'tablet';
		} else {
			return 'desktop';
		}
	}

	getIPAddress(): string {
		const cookies = document.cookie;
		const cookiesArray = cookies.split(';');
		for (let i = 0; i < cookiesArray.length; i++) {
			const cookie = cookiesArray[i].trim();
			if (cookie.indexOf('GeoIpClientIpAddress=') === 0) {
				return cookie.substring('GeoIpClientIpAddress='.length);
			}
		}
		return 'IP address not found';
	}

	gobackHistory() {
		history.go(-1);
	}

	_duplicateMetanavigation() {
		const source = $('.js-metanavigation-container--source');
		const destination = $('.js-metanavigation-container--destination');

		$(source)
			.clone()
			.appendTo(destination);
	}
	_initStickyHeader($ctx: JQuery) {
		let lastScrollTop: number = 0;
		let currentScrollTop = 0;

		$(classes.wrapper).addClass(classes.initSticky);
		$(classes.wrapper).addClass(classes.stateScrollTopNoTransition);

		if ($(window).scrollTop() < $ctx.outerHeight()) {
			$(classes.wrapper).addClass(classes.stateOnTop);
		} else {
			$(classes.wrapper).addClass(classes.stateScrollUp);
			$(classes.wrapper).removeClass(classes.stateOnTop);
		}

		$(window).scroll(function () {
			if (preventStickyHeaderScrollBehaviour) {
				return;
			}
			currentScrollTop = $(window).scrollTop();
			const navBarHeight = $ctx.height();
			const delta =
				currentScrollTop < navBarHeight || preventStickyHeaderAppearing
					? 0
					: 10;
			const viewport = getCurrentBreakpoint() as string;

			if (!$(classes.wrapper).hasClass(classes.burgerActiveClass)) {
				if (lastScrollTop < currentScrollTop) {
					if (currentScrollTop >= navBarHeight) {
						$(classes.wrapper).addClass(classes.stateScrollUp);
						if (viewport === 'large' || viewport === 'extra-large') {
							$(window).trigger('closeNavigation');
						}
					}
				} else {
					if (lastScrollTop - currentScrollTop > delta) {
						if (preventStickyHeaderAppearing) {
							// if "Prevent Sticky Header Mode" is active, always hide header, also on scrolling to top
							$(classes.wrapper).addClass(classes.stateScrollUp);
						} else {
							$(classes.wrapper).removeClass(classes.stateScrollUp);
						}
					}
					if (lastScrollTop >= navBarHeight && currentScrollTop >= navBarHeight) {
						$(classes.wrapper).removeClass(classes.stateScrollTopNoTransition);
					}
				}

				if (currentScrollTop === 0) {
					$(classes.wrapper).addClass(classes.stateOnTop);
					$(classes.wrapper).addClass(classes.stateScrollTopNoTransition);
				}

				lastScrollTop = currentScrollTop;

				if (currentScrollTop < navBarHeight) {
					return;
				}

				$(classes.wrapper).removeClass(classes.stateOnTop);
			}
		});
	}
	_calcTransitionTime(transitionString: string) {
		const numberPart = transitionString.match(/[\d\.]+/)[0];
		const number = parseFloat(numberPart);
		return !isNaN(number) ? number * 500 : 200;
	}
	_initNavInPage() {
		const bodyHtml = document.getElementsByTagName('body')[0].innerHTML;
		const anchorNameId = 'data-anchor-id';
		if (
			bodyHtml.indexOf(anchorNameId) == -1 ||
			$(`.${classes.headerStickyBarHideNav}`).length > 0
		) {
			noHasAnchor = true;
		}
		if (
			$(`.${classes.pageShare}`).length == 0 &&
			$(`.${classes.ctaButton}`).length == 0
		) {
			noHasPageShare = true;
		}
		if (noHasAnchor && noHasPageShare) {
			$(`.${classes.headerStickyBar}`).hide();
		}
	}
}
